// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2huP9","inner":"Footer_inner__22eCo"};